import React from 'react';
import '@icon/material-icons/material-icons.css';
import './scss/app.scss';
import { useSelector } from 'react-redux';
import AppSelection from './components/pages/AppSelection/AppSelection';
import Login from './components/pages/Login/Login';

function App() {
  const auth = useSelector(state => state.auth);
  return auth.isLoggedIn ? <AppSelection /> : <Login />;
}

export default App;
